import { ReactNode } from 'react';

export enum AgentId {
  AGENT_ID_UNSPECIFIED = 'AGENT_ID_UNSPECIFIED',
  AGENT_QUERY_GENIE = 'AGENT_QUERY_GENIE',
  AQL_AGENT = 'AQL_AGENT',
  ENTITY_MAPPING_AGENT = 'ENTITY_MAPPING_AGENT',
  INCIDENT_RULE_GENERATION_AGENT = 'INCIDENT_RULE_GENERATION_AGENT',
  REMEDIATION_COPILOT = 'REMEDIATION_COPILOT',
}

export enum AgenticWorkflowMode {
  AGENTIC_WORKFLOW_MODE_UNSPECIFIED = 'AGENTIC_WORKFLOW_MODE_UNSPECIFIED',
  AGENTIC_WORKFLOW_MODE_INTERACTIVE = 'AGENTIC_WORKFLOW_MODE_INTERACTIVE',
  AGENTIC_WORKFLOW_MODE_AUTONOMOUS = 'AGENTIC_WORKFLOW_MODE_AUTONOMOUS',
}

export interface AgenticSessionInput {
  agentId: AgentId;
  workflowMode: AgenticWorkflowMode;
  additionalParams?: Record<string, any>;
}

export enum CopilotChatMessageType {
  CONVERSATION_MESSAGE_TYPE_AI = 'CONVERSATION_MESSAGE_TYPE_AI',
  CONVERSATION_MESSAGE_TYPE_USER = 'CONVERSATION_MESSAGE_TYPE_USER',
  CONVERSATION_MESSAGE_TYPE_SUMMARY = 'CONVERSATION_MESSAGE_TYPE_SUMMARY',
  ERROR = 'ERROR',
}

export type ChatMessage = {
  type: CopilotChatMessageType;
  content: string;
  timestamp: string;
  structuredOutput?: any;
  state?: any;
  isError?: boolean;
  loopId?: string;
};

export type TCopilotError = { message: string; type: ChatbotErrorType };

export const enum ChatbotErrorType {
  NOT_FOUND = 'NOT_FOUND',
  INTERNAL = 'INTERNAL',
  QUOTA_EXCEEDED = 'QUOTA_EXCEEDED',
}

export type TCopilotActions = ((message: ChatMessage & { sessionId: string }) => ReactNode)[];

type TGetConfirmDialogConfig = (lastMessage?: ChatMessage) => { title: string; body: string };

type TOnAgentResponse = (message: ChatMessage) => void;

export type TSessionProps = {
  actions: TCopilotActions;
  getConfirmDialogConfig?: TGetConfirmDialogConfig;
  retainSessionOnClose?: boolean;
  onAgentResponse?: TOnAgentResponse;
} & {
  agentId: AgentId;
  additionalParams: Record<string, any>;
};

export type UserPrompt = { sessionId: string; message: string; isStateUpdated?: boolean; stateUpdate?: TAgentState };

export type TAgentState = Record<string, unknown> | undefined;

export enum CustomOperationName {
  SUMMARIZE_CHAT = 'SUMMARIZE_CHAT',
}

export interface OperationInput {
  sessionId: string;
  operationName: CustomOperationName;
  data?: any;
}

export enum ReactionType {
  LIKED = 'THUMBS_UP',
  DISLIKED = 'THUMBS_DOWN',
}

export interface FeedbackInput {
  loopId: string;
  sessionId: string;
  reactionType: ReactionType;
  freeText?: string;
  categories?: string[];
}
